import React, { useState, useEffect, useRef } from "react";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { message, Modal } from "antd";
import {
  newsIconUpload,
  newsImageUpload,
  newsPost,
  resetNewsImage,
  updateNewsSliderImages,
  validateSlugUrl,
} from "../../redux/news/NewsSlice";
import {
  getWordCount,
  isContentWithinLimit,
  resolveExclusiveToggle,
  truncateToWordLimit,
} from "../../utils/newsValidation";
import { MdGTranslate } from "react-icons/md";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const AddNews = () => {
  const dispatch = useDispatch();
  const { newsSlider, isnewsSliderLoading, newsthumb, newsicon } = useSelector(
    (store) => store.newsAdmin
  );
  const { allCategorys } = useSelector((store) => store.category);
  const { totalAdminNews } = useSelector((store) => store.newsAdmin);
  const { data, mandals } = useSelector((state) => state.districts);
  const stateData = data[0];

  const [messageApi, contextHolder] = message.useMessage();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [btnLoading, setbtnLoading] = useState(false);
  const [btnPress, setbtnPress] = useState(false);
  const [categroy, setCategroy] = useState("");
  const [categroyId, setCategroyId] = useState("");
  const [checkslugUrl, setCheckSlugUrl] = useState("");
  const [isBreakingNews, setIsBreakingNews] = useState(false);
  const [isSlider, setIsSlider] = useState(false);

  const [newsTitleInEnglish, setNewsTitleInEnglish] = useState("");
  const [newsTitleInTelugu, setNewsTitleInTelugu] = useState("");
  const [newsContentInEnglish, setNewsContentInEnglish] = useState("");
  const [newsContentInTelugu, setNewsContentInTelugu] = useState("");
  const [village, setVillage] = useState("");
  const [villageEng, setVillageEng] = useState("");
  const [mandal, setMandal] = useState("");
  const [mandalInTelugu, setMandalInTelugu] = useState("");

  const [metaKeywords, setMetaKeywords] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [file, setFile] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [originalFile, setOriginalFile] = useState(null);
  const [temp, setTemp] = useState("");
  const cropperRef = useRef(null);
  const adminData = JSON.parse(localStorage.getItem("admin"));

  const mandalsData = mandals
    .filter((item) => item.districts.english === districtName)
    .map((item) => item.mandal);

  const imageRemoveClick = (e, imagename) => {
    let imagearray = newsSlider;
    imagearray = imagearray.filter((image) => image !== imagename);
    dispatch(updateNewsSliderImages(imagearray));
  };

  const checkSlugExists = (slug) => {
    return totalAdminNews.some((item) => item.slugUrl === slug);
  };

  useEffect(() => {
    if (newsTitleInEnglish) {
      const slug = newsTitleInEnglish
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with '-'
        .replace(/[^a-z0-9-]/g, "") // Remove special characters except '-'
        .replace(/-{2,}/g, "-") // Replace multiple '-' with a single '-'
        .replace(/^-+|-+$/g, ""); // Remove '-' from start or end
      if (checkSlugExists(slug)) {
        setCheckSlugUrl("error");
      } else {
        setCheckSlugUrl(slug);
      }
    }
  }, [newsTitleInEnglish, totalAdminNews]);

  const thumbnailChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          dispatch(newsImageUpload({ slider: reader.result }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const translateAllFields = async () => {
    const translateText = async (text, sourceLang, targetLang) => {
      if (!text) return "";
      const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(
        text
      )}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        const translatedText = Array.isArray(data?.[0])
          ? data[0].map((part) => part?.[0] || "").join("")
          : "";
        return translatedText || text;
      } catch (error) {
        console.error("Translation error", error);
        return text;
      }
    };

    const translateMissingPair = async (englishText, teluguText) => {
      if (englishText?.trim() && !teluguText?.trim()) {
        return {
          telugu: await translateText(englishText, "en", "te"),
        };
      }
      if (teluguText?.trim() && !englishText?.trim()) {
        return {
          english: await translateText(teluguText, "te", "en"),
        };
      }
      return {};
    };

    const [titleTranslation, contentTranslation, villageTranslation] =
      await Promise.all([
        translateMissingPair(newsTitleInEnglish, newsTitleInTelugu),
        translateMissingPair(newsContentInEnglish, newsContentInTelugu),
        translateMissingPair(villageEng, village),
      ]);

    if (titleTranslation.english) setNewsTitleInEnglish(titleTranslation.english);
    if (titleTranslation.telugu) setNewsTitleInTelugu(titleTranslation.telugu);
    if (contentTranslation.english) setNewsContentInEnglish(contentTranslation.english);
    if (contentTranslation.telugu) setNewsContentInTelugu(contentTranslation.telugu);
    if (villageTranslation.english) setVillageEng(villageTranslation.english);
    if (villageTranslation.telugu) setVillage(villageTranslation.telugu);
  };

  const handleToggleValue = (type) => {
    const nextState = resolveExclusiveToggle(type, isSlider, isBreakingNews);
    setIsSlider(nextState.slider);
    setIsBreakingNews(nextState.breaking);
  };

  const englishWordLimitOk = isContentWithinLimit(newsContentInEnglish);
  const teluguWordLimitOk = isContentWithinLimit(newsContentInTelugu);

  const handleWordLimitedContent = (setter, value) => {
    const nextValue = truncateToWordLimit(value);
    setter(nextValue);

    if (getWordCount(value) > 50) {
      messageApi.open({
        type: "warning",
        content: "Maximum 50 words allowed in each language.",
      });
    }
  };

  const getNewsValidationError = () => {
    if (!categroyId && !selectedState) return "Please select a state or category.";
    if (!newsTitleInEnglish.trim()) return "Please enter News Title in English.";
    if (!newsTitleInTelugu.trim()) return "Please enter News Title in Telugu.";
    if (!newsContentInEnglish.trim()) return "Please enter News Content in English.";
    if (!newsContentInTelugu.trim()) return "Please enter News Content in Telugu.";
    if (checkslugUrl === "error") return "This news title already exists. Please use a unique title.";
    if (!englishWordLimitOk) return `English content exceeds the 50 word limit (current: ${getWordCount(newsContentInEnglish)}).`;
    if (!teluguWordLimitOk) return `Telugu content exceeds the 50 word limit (current: ${getWordCount(newsContentInTelugu)}).`;
    if (newsSlider.length === 0) return "Please upload at least one news image.";
    return "";
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    setbtnLoading(true);
    setbtnPress(true);

    const validationError = getNewsValidationError();

    if (validationError) {
      setbtnLoading(false);
      messageApi.open({
        type: "error",
        content: validationError,
      });
      return;
    }

    const formData = {
      newsTitleInTelugu: newsTitleInTelugu,
      newsTitleInEnglish: newsTitleInEnglish,
      slugUrl: newsTitleInEnglish,
      newsContentInTelugu: newsContentInTelugu,
      newsContentInEnglish: newsContentInEnglish,
      category: categroy || null,
      categoryId: categroyId || null,
      metaKeywords: metaKeywords,
      slider: newsSlider,
      thumbnail: newsthumb,
      icon: newsicon,
      sliderShow: isSlider,
      breakingNewsShow: isBreakingNews,
      newsAprovelText: "Approved",
      reporterId: adminData.id,
      reporterName: adminData.name,
      email: adminData.email,

      district: districtName,
      distinctTelugu: temp,
      state: selectedState,
      stateTelugu:
        selectedState === "Telangana" ? "తెలంగాణ" : "ఆంధ్ర ప్రదేశ్",
      mandal: mandal,
      mandalTelugu: mandalInTelugu,
      village: villageEng,
      villageTelugu: village,
    };
    const data = await dispatch(newsPost(formData));

    if (data.payload.success) {
      messageApi.open({
        type: "success",
        content: "News created successfully",
      });
      setNewsContentInTelugu("");
      setNewsContentInEnglish("");
      setNewsTitleInEnglish("");
      setNewsTitleInTelugu("");
      setMetaKeywords([]);
      await dispatch(resetNewsImage());
      setbtnLoading(false);
      setbtnPress(false);
      setDistrictName("");
      setSelectedState("");
    } else {
      setbtnLoading(false);
      messageApi.open({
        type: "error",
        content: data?.payload?.message || "Please fill all required news fields correctly.",
      });
    }
    setbtnLoading(false);
  };

  const LoadingButton = styled(Button)(({ theme }) => ({
    position: "relative",
  }));

  const LoadingIndicator = styled(CircularProgress)(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  }));

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(URL.createObjectURL(file));
      setOriginalFile(file);
    }
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    const croppedCanvas = cropper.getCroppedCanvas();
    if (croppedCanvas) {
      const croppedImageUrl = croppedCanvas.toDataURL("image/jpeg");
      setFile(croppedImageUrl);
      setShowPopup(false);
      dispatch(newsIconUpload({ slider: croppedImageUrl }));
    }
  };

  const handleReCrop = () => {
    if (originalFile) {
      setFile(URL.createObjectURL(originalFile));
      setShowPopup(true);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="main_fragnent_container p-2">
        <div className="profile_container_header">
          <div className="profile_co_header_left">
            <span>Add News</span>
            <span
              style={{
                visibility: "hidden",
              }}
            >
              Student
            </span>
          </div>
          <div className="profile_co_header_right"></div>
        </div>
        <div className="main_recha_container">
          <div className="inputs_container">
            <div className="dn_input_box">
              <TextField
                id="select"
                label="Select category"
                select
                className="input_style"
                value={categroyId}
                onChange={(e) => {
                  const selected = allCategorys.find(
                    (cat) => cat._id === e.target.value
                  );
                  setCategroyId(e.target.value);
                  setCategroy(selected.nameInTelugu);
                }}
                size="small"
              >
                {allCategorys &&
                  allCategorys.map((data, index) => (
                    <MenuItem key={index} value={data._id}>
                      {data.nameInTelugu} ({data.nameInEnglish})
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Title Telugu"
                multiline
                rows={1}
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                contentEditable={false}
                value={newsTitleInTelugu}
                onChange={(e) => setNewsTitleInTelugu(e.target.value)}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label={
                  checkslugUrl === "error"
                    ? "Category Already Exists"
                    : "Category Name In English"
                }
                multiline
                rows={1}
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                error={checkslugUrl === "error"}
                fullWidth
                contentEditable={false}
                value={newsTitleInEnglish}
                onChange={(e) => setNewsTitleInEnglish(e.target.value)}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Content (Telugu)"
                multiline
                rows={8}
                variant="outlined"
                id="text"
                className="input_style"
                error={(newsContentInTelugu === "" && btnPress) || (!teluguWordLimitOk && btnPress)}
                helperText={
                  newsContentInTelugu === "" && btnPress
                    ? "Please enter News Content (Telugu)"
                    : !teluguWordLimitOk
                    ? `Telugu content exceeds the ${50} word limit (current: ${getWordCount(newsContentInTelugu)}).`
                    : ""
                }
                value={newsContentInTelugu}
                onChange={(e) => handleWordLimitedContent(setNewsContentInTelugu, e.target.value)}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Content (English)"
                multiline
                rows={8}
                variant="outlined"
                id="text"
                className="input_style"
                error={(newsContentInEnglish === "" && btnPress) || (!englishWordLimitOk && btnPress)}
                helperText={
                  newsContentInEnglish === "" && btnPress
                    ? "Please enter News Content (English)"
                    : !englishWordLimitOk
                    ? `English content exceeds the ${50} word limit (current: ${getWordCount(newsContentInEnglish)}).`
                    : ""
                }
                value={newsContentInEnglish}
                onChange={(e) => handleWordLimitedContent(setNewsContentInEnglish, e.target.value)}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Keywords"
                multiline
                rows={3} // Adjust rows as needed
                variant="outlined"
                id="text"
                className="input_style"
                error={metaKeywords === "" && btnPress}
                helperText={
                  metaKeywords === "" && btnPress
                    ? "Please enter News Keywords"
                    : ""
                }
                value={metaKeywords}
                onChange={(e) => setMetaKeywords(e.target.value)}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </div>
            <div className="dn_input_box">
              <div className="translate_container">
                <button className="translate_btn" onClick={translateAllFields}>
                  <MdGTranslate className="translate_icon" />
                  <span className="translate_text">Click to Translate</span>
                </button>
              </div>
            </div>
            <div className="dn_input_box">
              <TextField
                id="select-state"
                label="Select State"
                select
                className="input_style"
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                size="small"
              >
                <MenuItem value="Telangana">Telangana</MenuItem>
                <MenuItem value="Andhra Pradesh">Andhra Pradesh</MenuItem>
              </TextField>
            </div>

            {stateData && (
              <div className="dn_input_box">
                <TextField
                  id="select-district"
                  label="Select District"
                  select
                  className="input_style"
                  value={districtName}
                  onChange={(e) => setDistrictName(e.target.value)}
                  size="small"
                >
                  {stateData[selectedState]?.map((district, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => setTemp(district.telugu)}
                      value={district.english}
                    >
                      {district.english} ({district.telugu})
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}

            <div className="dn_input_box">
              <TextField
                label="Mandal"
                id="Mandal"
                select
                name="mandal"
                className="input_style"
                value={mandal}
                onChange={(e) => setMandal(e.target.value)}
                variant="outlined"
                size="small"
              >
                {mandalsData.map((mandal, index) => (
                  <MenuItem
                    key={index}
                    value={mandal.english}
                    onClick={() => setMandalInTelugu(mandal.telugu)}
                  >
                    {mandal.english} ({mandal.telugu})
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <div className="dn_input_box">
              <TextField
                label="Village (Telugu)"
                name="Village"
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                contentEditable={false}
                value={village}
                onChange={(e) => setVillage(e.target.value)}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Village (English)"
                name="Village"
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                contentEditable={false}
                value={villageEng}
                onChange={(e) => setVillageEng(e.target.value)}
              />
            </div>
            <div className="dn_input_box_new">
              <div className="input_style">
                <h6>Set Breaking News</h6>
                <div className="checkbox-wrapper-6">
                  <input
                    className="tgl tgl-light"
                    id="cb1-1"
                    type="checkbox"
                    checked={isBreakingNews}
                    onChange={() => handleToggleValue("breaking")}
                  />
                  <label className="tgl-btn" htmlFor="cb1-1"></label>
                </div>
              </div>
            </div>
            <div className="dn_input_box_new">
              <div className="input_style">
                <h6>Set Slider</h6>
                <div className="checkbox-wrapper-6">
                  <input
                    className="tgl tgl-light"
                    id="cb1-6"
                    type="checkbox"
                    checked={isSlider}
                    onChange={() => handleToggleValue("slider")}
                  />
                  <label className="tgl-btn" htmlFor="cb1-6"></label>
                </div>
              </div>
            </div>
            {/* <div className="dn_input_box_new"></div> */}

            <div className="dn_input_box">
              <div className="input_style">
                <h6>News Image</h6>

                <input
                  type="file"
                  id="img"
                  name="img"
                  accept="image/*"
                  onChange={thumbnailChange}
                  multiple
                  style={
                    newsSlider.length === 0 && btnPress
                      ? {
                          border: "1px solid red",
                          width: "100%",
                          background: "#ffe6e6",
                          cursor: "pointer",
                        }
                      : {
                          cursor: "pointer",
                        }
                  }
                />

                {newsSlider.length === 0 && btnPress && (
                  <h6>
                    <span style={{ color: "tomato" }}>
                      Please uploade image
                    </span>
                  </h6>
                )}

                {!isnewsSliderLoading && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {newsSlider.map((image, index) => (
                      <div
                        style={{
                          position: "relative",
                          height: "100px",
                          width: "150px",
                          margin: "5px",
                        }}
                        key={index}
                      >
                        <img src={image} height="100%" alt="img" />
                        <span
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 3,
                          }}
                          onClick={(e) => imageRemoveClick(e, image, index)}
                        >
                          <h6
                            style={{
                              fontWeight: "bold",
                              color: "red",
                              cursor: "pointer",
                              fontSize: "20px",
                            }}
                          >
                            X
                          </h6>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="dn_input_box">
              <div className="az-container">
                <h2 className="az-title">Upload Image for Mobile</h2>
                <label className="az-upload-label">
                  <span>Choose Image</span>
                  <input
                    type="file"
                    className="az-hidden-input"
                    onChange={handleFileChange}
                  />
                </label>
                {file && (
                  <div className="az-preview-container">
                    <img
                      src={file}
                      alt="Original"
                      className="az-preview-image"
                      onClick={handleReCrop}
                    />
                    {showPopup && (
                      <div className="az-popup-overlay">
                        <div className="az-popup-content">
                          <Cropper
                            src={file}
                            style={{ height: 300, width: "100%" }}
                            initialAspectRatio={1}
                            aspectRatio={1}
                            guides={false}
                            ref={cropperRef}
                            className="az-cropper-style"
                          />
                          <button
                            onClick={handleCrop}
                            className="az-crop-button"
                          >
                            Crop Image
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="dn_input_box"></div>
            <div className="dn_input_box"></div>
            <div className="button_container">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setPreviewOpen(true)}
                style={{ marginRight: 12 }}
              >
                Preview
              </Button>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={(e) => handlesubmit(e)}
                disabled={btnLoading}
              >
                {btnLoading ? (
                  <>
                    LOading
                    <LoadingIndicator size={24} />
                  </>
                ) : (
                  "Submit"
                )}
              </LoadingButton>
            </div>
            <Modal
              title="News Preview"
              open={previewOpen}
              onCancel={() => setPreviewOpen(false)}
              footer={null}
            >
              <div>
                <h4>{newsTitleInEnglish || "Untitled News"}</h4>
                <p>
                  <strong>Telugu:</strong> {newsTitleInTelugu || "-"}
                </p>
                <p>
                  <strong>Views:</strong> {0}
                </p>
                <div>
                  <strong>Content (English):</strong>
                  <p>{newsContentInEnglish || "-"}</p>
                </div>
                <div>
                  <strong>Content (Telugu):</strong>
                  <p>{newsContentInTelugu || "-"}</p>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNews;
